import { delay, fork, takeEvery } from 'saga-ts';
import { invokeEvent, l, playBackgroundMusic, toggleBackgroundMusic } from 'shared-base';

export const saga = {
  id: 'sloyd.animation',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['ANIMATION'],
  },
};

type Verb =
  | 'play' //
  | 'pause';

type Action = {
  type: 'ANIMATION';
  verb: Verb;
  id: string;
  payload: Json;
};

const map: Record<Verb, any> = {
  play: play,
  pause: pause,
};

export function* play(action: Action, project: IProject) {
  try {
    playBackgroundMusic('/funk2.mp3', 0.5, false, 'MUSIC_TIME');
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* pause(action: Action, project: IProject) {
  try {
    toggleBackgroundMusic();
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* animation(action: any) {
  const { verb, id } = action;
  yield delay(10);
  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.animation ${verb} on ${id}`);

  yield* fork(saga, action);
}

export function* root() {
  yield takeEvery('ANIMATION', animation);
}
